import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import NavigationBar from '../../components/ui/NavigationBar';
import FloatingNavigation from '../../components/ui/FloatingNavigation';
import HeroSection from './components/HeroSection';
import ServicesGrid from './components/ServicesGrid';
import AboutSection from './components/AboutSection';
import Footer from './components/Footer';

const Homepage = () => {
  useEffect(() => {
    // Scroll to top when component mounts
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-background">
      {/* Navigation */}
      <NavigationBar />
      <FloatingNavigation />
      {/* Hero Section */}
      <section id="hero">
        <HeroSection />
      </section>
      {/* Services Section */}
      <section id="services" className="py-16 lg:py-24">
        <ServicesGrid />
      </section>
      {/* About Section */}
      <section id="about" className="py-16 lg:py-24 bg-card/30">
        <AboutSection />
      </section>
      {/* Contact Section */}
      <section id="contact" className="py-16 lg:py-24">
        <div className="max-w-4xl mx-auto container-responsive text-center">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            <h2 className="text-responsive-lg font-bold text-foreground mb-4">
              Ready to Get Started?
            </h2>
            <p className="text-text-secondary mb-8 max-w-2xl mx-auto">
              Transform your business with our modern solutions. Contact us today for a free consultation.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <motion.a
                href="/contact"
                className="inline-flex items-center justify-center px-8 py-3 bg-accent text-accent-foreground font-medium rounded-lg hover:bg-accent/90 transition-colors duration-200"
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
              >
                Contact Us
              </motion.a>
              <motion.a
                href="/services"
                className="inline-flex items-center justify-center px-8 py-3 border border-accent text-accent font-medium rounded-lg hover:bg-accent hover:text-accent-foreground transition-colors duration-200"
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
              >
                View Services
              </motion.a>
            </div>
          </motion.div>
        </div>
      </section>
      {/* Footer */}
      <Footer />
    </div>
  );
};

export default Homepage;